import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent implements OnInit {

  private paramSubscription!: Subscription;
  productId: string;
  productsArr: any = [
    {
      id: 1,
      image: 'assets/img/Oil-Images/5W30.jpeg',
      name: '5W30 - 10,000 SN',
      description: 'Maecenas non tortor ac massa auctor congue. Morbi non ex at nulla blandit euismod, Donec sollicitudin ipsum in urna blandit imperdiet.Maecenas pharetra convallis quam non auctor.Curabitur nec leo tristique, maximus lacus imperdiet, tincidunt quam, Maecenas luctus hendrerit sagittis.',
      details: [
        {
          id: 11,
          point: 'APLStandards: APISP, SN'
        },
        {
          id: 12,
          point: 'ILSAC Standards: GF-6A, GF-6B'
        },
        {
          id: 13,
          point: 'ACEA Standards: ACEA:A5/B5 (HTHS < 3.5), A3/B3, A3/B4'
        },
        {
          id: 14,
          point: 'Manufacturer Approvals:'
        },
        {
          id: 15,
          point: 'MB 229.3 / 229.5'
        },
        {
          id: 16,
          point: 'Ford WSS-M2C913-C/D, WSS-M2C925-B'
        },
        {
          id: 17,
          point: 'Renault RN0700 / RN0710'
        },
        {
          id: 18,
          point: 'VW 502.00 / 505.00'
        },
        {
          id: 19,
          point: 'PSA B71 2296'
        },
        {
          id: 20,
          point: 'Opel GM-LL-B-025'
        },
      ]
    },
    {
      id: 2,
      image: 'assets/img/Oil-Images/10W40.jpeg',
      name: '10W40 - 10,000 SN',
      description: 'Maecenas non tortor ac massa auctor congue. Morbi non ex at nulla blandit euismod, Donec sollicitudin ipsum in urna blandit imperdiet.Maecenas pharetra convallis quam non auctor.Curabitur nec leo tristique, maximus lacus imperdiet, tincidunt quam, Maecenas luctus hendrerit sagittis.',
      details: [
        {
          id: 21,
          point: 'API Standards: API SN/CE'
        },
        {
          id: 22,
          point: 'ACEA Standards: ACEA:A3/B3, A3/B4'
        },
        {
          id: 23,
          point: 'Manufacturer Approvals:'
        },
        {
          id: 24,
          point: 'MB 229.1 / 229.3 / 229.5'
        },
        {
          id: 25,
          point: 'Ford WSS-M2C913-C/D, WSS-M2C925-B'
        },
        {
          id: 26,
          point: 'Renault RN0700 / RN0710'
        }
      ]
    },
    {
      id: 3,
      image: 'assets/img/Oil-Images/20W50.jpeg',
      name: '20W50 - 5000 SL',
      description: 'Maecenas non tortor ac massa auctor congue. Morbi non ex at nulla blandit euismod, Donec sollicitudin ipsum in urna blandit imperdiet.Maecenas pharetra convallis quam non auctor.Curabitur nec leo tristique, maximus lacus imperdiet, tincidunt quam, Maecenas luctus hendrerit sagittis.',
      details: [
        {
          id: 31,
          point: 'API Standards: API SN/CF'
        },
        {
          id: 32,
          point: 'ACEA Standards: ACEA A3/B3, A3/B4'
        },
        {
          id: 33,
          point: 'Manufacturer Approvals:'
        },
        {
          id: 34,
          point: 'MB 226.5 / 229.1 / 229.3 / 229.5'
        },
        {
          id: 35,
          point: 'VW 501.01 / 505.00'
        },
        {
          id: 36,
          point: 'Renault RNO700 / RNO71O.'
        },
        {
          id: 37,
          point: 'Porsche A40'
        }
      ]
    },
    {
      id: 4,
      image: 'assets/img/Oil-Images/5W30.jpeg',
      name: 'Goldol Super Of 5w30',
      description: 'Maecenas non tortor ac massa auctor congue. Morbi non ex at nulla blandit euismod, Donec sollicitudin ipsum in urna blandit imperdiet.Maecenas pharetra convallis quam non auctor.Curabitur nec leo tristique, maximus lacus imperdiet, tincidunt quam, Maecenas luctus hendrerit sagittis.',
      details: [
        {
          id: 41,
          point: 'APLStandards: APISP, SN'
        },
        {
          id: 42,
          point: 'ILSAC Standards: GF-6A, GF-6B'
        },
        {
          id: 43,
          point: 'ACEA Standards: ACEA:A5/B5 (HTHS < 3.5), A3/B3, A3/B4'
        },
        {
          id: 44,
          point: 'Manufacturer Approvals:'
        },
        {
          id: 45,
          point: 'MB 229.3 / 229.5'
        },
        {
          id: 46,
          point: 'Ford WSS-M2C913-C/D, WSS-M2C925-B'
        },
        {
          id: 47,
          point: 'Renault RN0700 / RN0710'
        },
        {
          id: 48,
          point: 'VW 502.00 / 505.00'
        },
        {
          id: 49,
          point: 'PSA B71 2296'
        },
        {
          id: 50,
          point: 'Opel GM-LL-B-025'
        },
      ]
    }
  ];
  currentProduct: any;
  productType: string;
  productKeyFeatures: any = [
    {
      id: 1,
      name: 'High Production Speed'
    },
    {
      id: 2,
      name: 'Precision Tension Control'
    },
    {
      id: 3,
      name: 'Advanced Yarn Path Design'
    },
    {
      id: 4,
      name: 'Computerized Control System (PLC/HMI)'
    },
    {
      id: 5,
      name: 'Yarn Fault Detection System'
    },
    {
      id: 6,
      name: 'Servo-Driven Creel or Auto-Creel System'
    },
    {
      id: 7,
      name: 'Precision Beam Winding'
    },
    {
      id: 8,
      name: 'Automatic Stop Motion'
    },
    {
      id: 9,
      name: 'Reverse Operation Capability'
    },
    {
      id: 10,
      name: 'Cooling & Dust Control Systems'
    },
    {
      id: 11,
      name: 'Energy-Efficient Drives'
    },
    {
      id: 12,
      name: 'Data Logging and Connectivity'
    }
  ];
  productTechnicalSpecifications: any = [
    {
      id: 1,
      title: 'Working Width',
      content: '1400mm to 2400 mm'
    },
    {
      id: 2,
      title: 'Flange Diameter',
      content: '800mm to 1400mm'
    },
    {
      id: 3,
      title: 'Max. Mechanical Speed',
      content: '1200mpm'
    },
    {
      id: 4,
      title: 'Max. Warping Speed',
      content: '1000mpm'
    },
    {
      id: 5,
      title: 'Drive',
      content: 'AC Invertors servo drive'
    },
    {
      id: 6,
      title: 'Controls',
      content: 'PLC base controls'
    },
    {
      id: 7,
      title: 'Motor (KW)',
      content: '15kw to 22kw'
    },
    {
      id: 8,
      title: 'Pressure Drum Roller',
      content: 'Rubber coated /hylum type'
    },
    {
      id: 9,
      title: 'Brakes',
      content: 'Quick hydraulic type'
    }
  ];

  constructor(public route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.paramSubscription = this.route.paramMap.subscribe(params => {
      this.productType = params.get('productType'); // ✅ Updates when navigating within the same page
      this.productId = params.get('productId'); // ✅ Updates when navigating within the same page
      this.currentProduct = this.getProductById(this.productId);
    });
  }

  getProductById(id: any): any {
    return this.productsArr.find(product => product.id == id);
  }

  ngOnDestroy(): void {
    if (this.paramSubscription) {
      this.paramSubscription.unsubscribe(); // ✅ Prevent memory leaks
    }
  }

}
